/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Switch as NativeSwitch,
	SwitchProps,
} from '@mantine/core';

import classes from './Switch.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Switch = (props: SwitchProps) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeSwitch
			className={classes.customSwitch}
			size="lg"
			radius={'xl'}
			classNames={classes}
			{...props}
		/>
	);
};
